import { XBuildifyPermissionSelection } from '@adornis/buildify/client/components/x-buildify-permission-selection.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { customElement, state } from 'lit/decorators.js';
import { netzPermissions } from '../../../db/permissions.js';

@customElement('cr-buildify-permission-selection')
export class CRBuildifyPermissionSelection extends XBuildifyPermissionSelection {
  @state() private override readonly _permissions = new RXController(this, [netzPermissions[4], netzPermissions[5]]);
}
